import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import {environment} from '../environment/environment'
import {SessionFeatureSupport, StaticConfig} from '../models/IStaticConfig'

const STATIC_CONFIG_KEY = 'staticConfig';
export const getStaticConfig = async (): Promise<AxiosResponse<StaticConfig>> => {
  try {
    const axiosConfig: AxiosRequestConfig = {
        headers: {
          'TenantAlias': environment.tenantAlias,
        },
      };

    const response = await axios.get(`${environment.controlServerEndpoint}/staticConfig`, axiosConfig);
    const staticConfig: StaticConfig  = response.data;

    const staticConfigFeatures = staticConfig.features;

    (Object.keys(staticConfigFeatures) as (keyof SessionFeatureSupport)[]).forEach((key) => {
      if (staticConfigFeatures[key] === 'true') {
        staticConfigFeatures[key] = true;
      } else if (staticConfigFeatures[key] === 'false') {
        staticConfigFeatures[key] = false;
      }
    });
    const updatedStaticConfig = {
      ...staticConfig,
      features: staticConfigFeatures 
    }

    console.log('this is updatye', updatedStaticConfig)

    localStorage.setItem(STATIC_CONFIG_KEY, JSON.stringify(updatedStaticConfig));
    return response;
  } catch (error) {
    console.error('Error fetching static config:', error);
    throw error;
  }
};